import { Component } from "@angular/core";
import { ImportsModule } from "../imports";
import { UserService } from "../services/user.service";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ImportsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  customer: string = "";
  apiKey: string = "";
  constructor(private userService: UserService) { }

  login() {
    this.userService.authenticate(this.customer, this.apiKey);
  }
}
